"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable */
/* tslint:disable */
var React = require("react");
var SortAscendingSmall = function (_a) {
    var size = _a.size, props = __rest(_a, ["size"]);
    return (React.createElement("svg", __assign({ viewBox: "0 0 18 18", fill: "currentColor", width: size || "18", height: size || "18" }, props),
        React.createElement("path", { d: "M4,4 L6,4 L6,7 L3,7 L3,5 C3,4.44771525 3.44771525,4 4,4 Z M4,5 L4,6 L5,6 L5,5 L4,5 Z M3,8 L9,8 L9,11 L3,11 L3,8 Z M4,9 L4,10 L8,10 L8,9 L4,9 Z M3,12 L11,12 L11,15 L4,15 C3.44771525,15 3,14.5522847 3,14 L3,12 Z M4,13 L4,14 L10,14 L10,13 L4,13 Z M14,5.70710678 L14,15 L13,15 L13,5.70710678 L11.8486277,6.86333881 C11.6571669,7.05560771 11.3460925,7.05626282 11.1538236,6.86480203 L11.1518691,6.86284481 C10.9591647,6.66877742 10.9590487,6.35561081 11.1516093,6.16140071 L13.5,3.79289322 L15.8584052,6.16917753 C16.0488852,6.36110159 16.05051,6.67023972 15.8620579,6.86415538 C15.6762527,7.0553474 15.370636,7.05971428 15.179444,6.87390907 L14,5.70710678 Z" })));
};
SortAscendingSmall.displayName = 'SortAscendingSmall';
exports.default = SortAscendingSmall;
/* tslint:enable */
/* eslint-enable */
//# sourceMappingURL=SortAscendingSmall.js.map